import { SignIn } from '@clerk/react';

export function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold tracking-tight">Edison</h1>
          <p className="text-sm text-muted-foreground mt-1">
            R&D Tax Incentive Evidence Platform
          </p>
        </div>
        <SignIn
          routing="hash"
          signUpUrl="/login"
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'shadow-none border rounded-lg',
            },
          }}
        />
      </div>
    </div>
  );
}
